import { parseDateToLocal } from 'shared/lib/dateFormatter';

/** Rate Management 위치 셀: 빈 값, 공백 표시하지 않음 */
function isBlankLocationDisplayPart(s) {
    if (s == null) return true;
    const t = String(s).trim();
    if (t === '') return true;
    if (t === '""' || t === "''") return true;
    return false;
}

function normalizedLocationPart(s) {
    return isBlankLocationDisplayPart(s) ? '' : String(s).trim();
}

export function formatPartnerNames(val) {
    if (val == null || val === '') return '';
    const list = Array.isArray(val) ? val : [val];
    return list
        .map((p) => (typeof p === 'object' && p !== null ? p.name || '' : String(p)))
        .filter(Boolean)
        .join('\n');
}

/**
 * @param {unknown} val
 * @param {{ nameOnly?: boolean }} [options] — nameOnly: true이면 객체/JSON 위치는 표시명(`name`)만 사용 (코드 접미 없음).
 */
export function formatLocation(val, options = {}) {
    const { nameOnly = false } = options;
    if (val == null) return '';
    if (typeof val === 'string' && isBlankLocationDisplayPart(val)) return '';

    let v = val;
    if (typeof val === 'string') {
        const trimmed = val.trim();
        if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
            try {
                v = JSON.parse(trimmed);
            } catch {
                return isBlankLocationDisplayPart(trimmed) ? '' : val;
            }
        } else {
            return isBlankLocationDisplayPart(trimmed) ? '' : trimmed;
        }
    }

    if (typeof v === 'object' && v !== null) {
        if (Array.isArray(v)) {
            return v
                .map((item) => formatLocation(item, options))
                .filter(Boolean)
                .join('\n');
        }
        const name = normalizedLocationPart(v.name);
        const code = normalizedLocationPart(v.code);
        if (nameOnly) {
            if (name) return name;
            if (code) return code;
            return '';
        }
        if (name && code) return `${code} | ${name}`;
        if (name) return name;
        if (code) return code;
    }
    return '';
}

export function formatMultiLineField(val) {
    if (val == null || val === '') return '';
    if (Array.isArray(val)) {
        return val
            .map((item) => {
                if (typeof item === 'string') return item;
                if (item?.hbl != null) return String(item.hbl);
                if (item?.cntr_number != null) return String(item.cntr_number);
                if (item?.volume != null) return String(item.volume);
                if (item?.il_location_id_deliver_to != null) return String(item.il_location_id_deliver_to);
                return '';
            })
            .filter(Boolean)
            .join('\n');
    }
    return String(val);
}

export function formatEtdEta(val) {
    if (val == null) return '';
    const date = parseDateToLocal(val);
    if (!date) return '';
    return date.toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' });
}
